import * as htmlToImage from "html-to-image";
import html2canvas from "html2canvas";
import { updateProjectImg } from "../../../Features/projectImage";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import { handleInverterType } from "../Electricals/electricalFunction";
import { inverterInformation } from "../../DataFiles/inverterInformation";

const takeScreenshot2 = async (mapRef, dispatch) => {
  if (!mapRef) {
    return false;
  }
  try {
    // const image = await htmlToImage.toPng(mapRef.current);
    const image = await htmlToImage.toPng(mapRef.current, {
      filter: (node) => {
        return true;
      },
      skipFonts: true,
    });

    dispatch(updateProjectImg({ structureImage: image }));

    return true; // Indicate success
  } catch (error) {
    console.error("Error taking screenshot:", error);
    return false; // Indicate failure
  }
};

const takeFirstScreenshot = async (screenRef, dispatch) => {
  if (!screenRef) {
    return false;
  }
  try {
    const input = document.getElementById("firstMap");
    const dataURI = await html2canvas(input, { useCORS: true });
    dispatch(updateProjectImg({ ImageSrc: dataURI.toDataURL() }));

    return true;
  } catch (error) {
    return false; // Indicate failure
  }
};

export const takeScreenShotOneLineDiagram = async (oneLineRef, dispatch) => {
  if (!oneLineRef) {
    return false;
  }
  try {
    const input = document.getElementById("oneLineImage");
    const dataURI = await html2canvas(input, { useCORS: true });
    // const image = await htmlToImage.toJpeg(oneLineRef.current);
    dispatch(updateProjectImg({ inverterImage: dataURI.toDataURL() }));
    // sessionStorage.setItem("oneLineDiagram", JSON.stringify(image));
    return true; // Indicate success
  } catch (error) {
    return false; // Indicate failure
  }
};

const createProjectPage = async ({
  roofInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  dispatch,
}) => {
  setLoader(true);
  setShowMarker(false);
  let screenshotResult = false;
  if (roofInfo.value.mapOption.mapTypeId === "gridView") {
    screenshotResult = true;
  } else {
    screenshotResult = await takeFirstScreenshot(screenRef, dispatch);
  }
  if (
    !roofInfo.value.siteName ||
    (!roofInfo.value.siteAddress.value &&
      roofInfo.value.mapOption.mapTypeId !== "gridView")
  ) {
    setEmptyValues(true);
    return false;
  } else if (!screenshotResult) {
    return false;
  } else {
    sessionStorage.setItem("projects", JSON.stringify(roofInfo));
    return true;
  }
};

const consumptionPage = ({ roofInfo }) => {
  if (
    !(roofInfo.value.financialAnalysis.jan > 0) ||
    !(roofInfo.value.financialAnalysis.feb > 0) ||
    !(roofInfo.value.financialAnalysis.mar > 0) ||
    !(roofInfo.value.financialAnalysis.apr > 0) ||
    !(roofInfo.value.financialAnalysis.may > 0) ||
    !(roofInfo.value.financialAnalysis.jun > 0) ||
    !(roofInfo.value.financialAnalysis.jul > 0) ||
    !(roofInfo.value.financialAnalysis.aug > 0) ||
    !(roofInfo.value.financialAnalysis.sep > 0) ||
    !(roofInfo.value.financialAnalysis.oct > 0) ||
    !(roofInfo.value.financialAnalysis.nov > 0) ||
    !(roofInfo.value.financialAnalysis.dec > 0)
  ) {
    return false;
  } else {
    return true;
  }
};

const configurationPage = ({ quantityInfo }) => {
  const roofData = quantityInfo?.roofData || [];

  if (roofData.length > 0) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (
        !(element.buildingHeight >= 0) ||
        !(element.buildingPitch >= 0) ||
        element.module === "Select" ||
        element.moduleType === "Select"
      ) {
        alert(
          `For Roof ${
            i + 1
          }, necessary information is missing on Roof configuration page.`
        );
        return false;
      } else if (element.images.length === 0) {
        alert(`There is no structure placement on Roof ${i + 1}`);
        return false;
      }
    }
    return true;
  } else if (roofData.length === 0) {
    return false;
  } else {
    return true;
  }
};

const electricalPage = ({ roofInfo, quantityInfo, dispatch }) => {
  const roofData = quantityInfo?.roofData || [];
  if (quantityInfo.electricalConfiguration === "Single Roof") {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i].inverterAnalysis;
      if (
        element.systemType === "Select" ||
        element.inverterManufacturer === "Select" ||
        element.inverterType === "Select"
      ) {
        alert(
          `Required electrical configuration for Roof ${
            i + 1
          } on Electrical page`
        );
        return false;
      } else {
        const roofDetail = roofData[i];
        const inverterDetail = element;
        const inverter = inverterInformation.find(
          (item) =>
            item.brand === inverterDetail.inverterManufacturer &&
            item.phase === inverterDetail.inverterPhase &&
            item.systemType === inverterDetail.systemType
        );
        const type = inverter.inverterType.find(
          (item) => item.name === inverterDetail.inverterType
        );
        if (window.location.pathname !== "/electrical") {
          handleInverterType({
            type,
            dispatch,
            roofInfo,
            roofDetail,
            inverterDetail,
            quantityInfo,
          });
        }
      }
    }
    return true;
  } else {
    if (
      roofInfo.value.inverterAnalysis.systemType === "Select" ||
      roofInfo.value.inverterAnalysis.inverterManufacturer === "Select" ||
      roofInfo.value.inverterAnalysis.inverterType === "Select"
    ) {
      alert("Required electrical configuration on Electrical page");
      return false;
    } else {
      const roofDetail = roofData[quantityInfo.roofNo];
      const inverterDetail = roofInfo.value.inverterAnalysis;
      const inverter = inverterInformation.find(
        (item) =>
          item.brand === inverterDetail.inverterManufacturer &&
          item.phase === inverterDetail.inverterPhase &&
          item.systemType === inverterDetail.systemType
      );
      const type = inverter.inverterType.find(
        (item) => item.name === inverterDetail.inverterType
      );
      if (window.location.pathname !== "/electrical") {
        handleInverterType({
          type,
          dispatch,
          roofInfo,
          roofDetail,
          inverterDetail,
          quantityInfo,
        });
      }
      return true;
    }
  }
};

const financialPage = ({ roofInfo }) => {
  if (roofInfo.value.financialAnalysis.tpc === 0) {
    return false;
  } else {
    return true;
  }
};

export const handleConsumption = async ({
  roofInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
  dispatch,
}) => {
  const pageRender = window.location.pathname;
  if (pageRender === "/createProject") {
    const createProjectResult = await createProjectPage({
      roofInfo,
      screenRef,
      setLoader,
      setEmptyValues,
      setShowMarker,
      dispatch,
    });
    if (!createProjectResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (createProjectResult) {
      navigate("/analytics");
    }
  } else {
    navigate("/analytics");
  }
};

export const handleConfiguration = async ({
  roofInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
  dispatch,
}) => {
  const pageRender = window.location.pathname;
  if (!(pageRender === "/createProject") && !(pageRender === "/analytics")) {
    navigate("/design");
    return false;
  }

  const consumptionResult = await consumptionPage({ roofInfo });
  if (pageRender === "/createProject") {
    const createProjectResult = await createProjectPage({
      roofInfo,
      screenRef,
      setLoader,
      setEmptyValues,
      setShowMarker,
      dispatch,
    });
    if (!createProjectResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!consumptionResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (createProjectResult && consumptionResult) {
      navigate("/design");
    }
  } else if (pageRender === "/analytics") {
    if (!consumptionResult) {
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (consumptionResult) {
      navigate("/design");
    }
  }
};

export const handleElectrical = async ({
  roofInfo,
  quantityInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
  mapRef,
  dispatch,
}) => {
  const pageRender = window.location.pathname;

  if (
    pageRender === "/summary" ||
    pageRender === "/financial" ||
    pageRender === "/electrical"
  ) {
    navigate("/electrical");
    return false;
  }
  const consumptionResult = await consumptionPage({ roofInfo });
  const configurationResult = await configurationPage({ quantityInfo });

  if (pageRender === "/createProject") {
    const createProjectResult = await createProjectPage({
      roofInfo,
      screenRef,
      setLoader,
      setEmptyValues,
      setShowMarker,
      dispatch,
    });
    if (!createProjectResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!consumptionResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!configurationResult) {
      setLoader(false);
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
    } else if (
      createProjectResult &&
      consumptionResult &&
      configurationResult
    ) {
      navigate("/electrical");
    }
  } else if (pageRender === "/analytics") {
    if (!consumptionResult) {
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!configurationResult) {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
    } else if (consumptionResult && configurationResult) {
      navigate("/electrical");
    }
  } else if (pageRender === "/design") {
    if (configurationResult) {
      setLoader(true);
      takeScreenshot2(mapRef, dispatch);
      setTimeout(() => {
        navigate("/electrical");
      }, 2000);
    } else if (
      quantityInfo.electricalConfiguration === "Single Roof" ||
      quantityInfo.roofData.length === 0
    ) {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
      dispatch(updateQuantityInfo({ allRoof: false }));
    }
  }
};

export const handleFinancial = async ({
  roofInfo,
  quantityInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
  mapRef,
  dispatch,
}) => {
  const pageRender = window.location.pathname;

  if (pageRender === "/summary" || pageRender === "/financial") {
    navigate("/financial");
    return false;
  }

  const consumptionResult = await consumptionPage({ roofInfo });
  const configurationResult = await configurationPage({ quantityInfo });
  const electircalResult = await electricalPage({
    roofInfo,
    quantityInfo,
    dispatch,
  });

  if (pageRender === "/createProject") {
    const createProjectResult = await createProjectPage({
      roofInfo,
      screenRef,
      setLoader,
      setEmptyValues,
      setShowMarker,
      dispatch,
    });
    if (!createProjectResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!consumptionResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields on consumption page, and then proceed to the next page."
      );
    } else {
      setLoader(false);
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
    }
  } else if (pageRender === "/analytics") {
    if (!consumptionResult) {
      alert(
        "First, enter all the required input fields on consumption page, and then proceed to the next page."
      );
    } else {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
    }
  } else if (pageRender === "/design") {
    if (!configurationResult) {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      }
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      setLoader(false);
    } else if (!electircalResult) {
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      setLoader(false);
      alert("First select all option on electircal page, then go to next page");
    } else if (electircalResult && configurationResult) {
      setLoader(true);
      takeScreenshot2(mapRef, dispatch);
      setTimeout(() => {
        navigate("/financial");
      }, 2000);
    }
  } else if (pageRender === "/electrical") {
    if (electircalResult) {
      navigate("/financial");
    } else {
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
    }
  }
};

export const handleSummary = async ({
  roofInfo,
  quantityInfo,
  screenRef,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
  mapRef,
  dispatch,
}) => {
  const pageRender = window.location.pathname;
  if (pageRender === "/summary") {
    navigate("/summary");
    return false;
  }
  const consumptionResult = await consumptionPage({ roofInfo });
  const configurationResult = await configurationPage({ quantityInfo });
  const electircalResult = await electricalPage({
    roofInfo,
    quantityInfo,
    dispatch,
  });
  const financialResult = await financialPage({ roofInfo });

  if (pageRender === "/createProject") {
    setLoader(true);
    const createProjectResult = await createProjectPage({
      roofInfo,
      screenRef,
      setLoader,
      setEmptyValues,
      setShowMarker,
      dispatch,
    });
    if (!createProjectResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields, and then proceed to the next page."
      );
    } else if (!consumptionResult) {
      setLoader(false);
      alert(
        "First, enter all the required input fields on consumption page, and then proceed to the next page."
      );
    } else {
      setLoader(false);
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
    }
  } else if (pageRender === "/analytics") {
    if (!consumptionResult) {
      alert(
        "First, enter all the required input fields on consumption page, and then proceed to the next page."
      );
    } else {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      } else {
        alert(
          "First, view the structure placement on the roof on the Roof Design page, then proceed to the next page."
        );
      }
    }
  } else if (pageRender === "/design") {
    setLoader(true);
    if (!configurationResult) {
      if (quantityInfo.roofData.length === 0) {
        alert(
          "Draw the roof and place structures for the roof  on design page."
        );
      }
      setLoader(false);
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
    } else if (!electircalResult) {
      setLoader(false);
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
    } else if (!financialResult) {
      setLoader(false);
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      alert(
        "First enter the project estimated cost on financial page, then go to next page"
      );
    } else if (electircalResult && configurationResult && financialResult) {
      setLoader(true);
      takeScreenshot2(mapRef, dispatch);
      setTimeout(() => {
        navigate("/summary");
      }, 2000);
    }
  } else if (pageRender === "/electrical") {
    if (!electircalResult) {
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      return false;
    } else if (!financialResult) {
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      alert(
        "First enter the project estimated cost on financial page, then go to next page"
      );
    } else if (electircalResult && financialResult) {
      setTimeout(() => {
        navigate("/summary");
      }, 500);
    }
  } else if (pageRender === "/financial") {
    if (!financialResult) {
      if (quantityInfo.electricalConfiguration === "Single Roof") {
        dispatch(updateQuantityInfo({ allRoof: false }));
      }
      alert(
        "First enter the project estimated cost on financial page, then go to next page"
      );
    } else if (financialResult) {
      navigate("/summary");
    }
  }
};
